import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { LOCALE_CONFIG, LocaleConfig } from './daterangepicker-locale-config';
import { DaterangepickerLocaleService } from '../services/daterangepicker-locale-service';

export function provideDaterangepickerLocale(
  config: LocaleConfig = {},
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: LOCALE_CONFIG, useValue: config },
    {
      provide: DaterangepickerLocaleService,
      useClass: DaterangepickerLocaleService,
      deps: [LOCALE_CONFIG],
    },
  ]);
}
